import React from "react";
import ReactDOM from "react-dom/client";
import { appRoutes } from "./routers/AppRoutes";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css'
import "bootstrap/dist/css/bootstrap.css";
import "./resources/styles/template.css";
import "./resources/styles/sinpepay.css?v=1.0.0";
import "react-tooltip/dist/react-tooltip.css";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={appRoutes}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
